import api from '../../../api';
import { finish, error } from '../../../modules/roles/actions/create';
import { kebabCase } from 'lodash';

export function request(dispatch, { data }) {
    Object.assign(data, {
        extends: []
    });

    api.put(`/roles/${data.id}`, data).then(
        response => dispatch(finish(response)),
        ({ errors }) => dispatch(error(errors))
    );
}
